const fallbackCopyTextToClipboard = (text: string, successMessage: string): void => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');

    if (successful) (window as any).bbApp.UI.notify({ text: successMessage, type: 'success' });
    else (window as any).bbApp.UI.notify({ text: 'Oops, unable to copy', type: 'danger' });
  } catch (err) {
    (window as any).bbApp.UI.notify({ text: 'Oops, unable to copy', type: 'danger' });
  }

  document.body.removeChild(textArea);
};

export const copyTextToClipboard = (text: string, successMessage = 'Text copied to clipboard'): void => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, successMessage);
    return;
  }

  navigator.clipboard.writeText(text).then(
    () => (window as any).bbApp.UI.notify({ text: successMessage, type: 'success' }),
    () => (window as any).bbApp.UI.notify({ text: 'Oops, unable to copy', type: 'danger' })
  );
};
